import { post } from "../../service/api";

const createInvoice = async (data) => {
    try {
        const response = await post(`/invoice`, data);
        return response;
    } catch (error) {
        console.error('Error createInvoice:', error);
        throw error;
    }
};

export default createInvoice;